var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pollution-home"}},[_c('div',{staticClass:"top"},[_c('license-bar'),_vm._v(" "),_c('pollution-map')],1),_vm._v(" "),_c('div',{staticClass:"bottom"},[_c('pollution-search')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-359ff944","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pollution/components/PollutionHome.vue
// module id = null
// module chunks = 